import { Helmet } from '@dr.pogodin/react-helmet';
import type React from 'react';
import type { MultiLang } from '../../config';
import Functions from '../../functions';

interface Props {
    lang: MultiLang;
}

const PageNotFound: React.FC<Props> = (props) => {
    const { lang } = props;
    const url = '/';

    return (
        <div>
            <Helmet>
                <title>Page Not Found - {Functions.siteTitle(lang)}</title>
            </Helmet>
            <h1>Page Not Found</h1>
            <section>
                <p>The page you were trying to access doesn&apos;t exist.</p>
                <p>
                    If the page does not automatically reload, please go to the <a href={url}>top page</a>
                </p>
            </section>
        </div>
    );
};

export default PageNotFound;
